import * as Yup from 'yup';
import { defaultTemperatureRange, defaultTemperatureRangeCelsius } from '../../utils/utils';
const getTemperatureRanges = (buildingTempUnit = 'F') => {
  const defaultCelsius = defaultTemperatureRangeCelsius;
  const defaultFahrenheit = defaultTemperatureRange;
  if (buildingTempUnit === 'C') {
    return {
      min: Math.min(defaultCelsius.heat[0], defaultCelsius.cool[0]),
      max: Math.max(defaultCelsius.heat[1], defaultCelsius.cool[1]),
      heatMin: defaultCelsius.heat[0],
      heatMax: defaultCelsius.heat[1],
      coolMin: defaultCelsius.cool[0],
      coolMax: defaultCelsius.cool[1],
      unit: '°C'
    };
  }
  return {
    min: Math.min(defaultFahrenheit.heat[0], defaultFahrenheit.cool[0]),
    max: Math.max(defaultFahrenheit.heat[1], defaultFahrenheit.cool[1]),
    heatMin: defaultFahrenheit.heat[0],
    heatMax: defaultFahrenheit.heat[1],
    coolMin: defaultFahrenheit.cool[0],
    coolMax: defaultFahrenheit.cool[1],
    unit: '°F'
  };
};

export const createGlobalThermostatSchema = (buildingTempUnit = 'F') => {
  const ranges = getTemperatureRanges(buildingTempUnit);
  
  return Yup.object().shape({
    occupiedSnapBackTemperature: Yup.number("Snap Back Setpoint required").typeError("Snap Back Setpoint must be a number")
      .when('buildingThermostatMasterControl', {
        is: true,
        then: (schema) => schema.when('enableOccupiedSnapBack', {
          is: true,
          then: (schema) => schema.required("Snap Back Setpoint required")
            .min(ranges.min, `Minimum temperature is ${ranges.min}${ranges.unit}`)
            .max(ranges.max, `Maximum temperature is ${ranges.max}${ranges.unit}`),
          otherwise: (schema) => schema.optional()
        }),
        otherwise: (schema) => schema.optional()
      }),
    occupiedSnapBackTemperatureAdjustment: Yup.number("Setpoint Refresh Frequency required").typeError("Setpoint Refresh Frequency must be a number")
      .when('buildingThermostatMasterControl', {
        is: true,
        then: (schema) => schema.when('enableOccupiedSnapBack', {
          is: true,
          then: (schema) => schema.required("Setpoint Refresh Frequency required")
            .min(1, "Setpoint Refresh Frequency must be greater than 0"),
          otherwise: (schema) => schema.optional()
        }),
        otherwise: (schema) => schema.optional()
      }),
    vacantSnapBackTemperature: Yup.number("Snap Back Setpoint required").typeError("Snap Back Setpoint must be a number")
      .when('buildingThermostatMasterControl', {
        is: true,
        then: (schema) => schema.when('enableVacantSnapBack', {
          is: true,
          then: (schema) => schema.required("Snap Back Setpoint required")
            .min(ranges.min, `Minimum temperature is ${ranges.min}${ranges.unit}`)
            .max(ranges.max, `Maximum temperature is ${ranges.max}${ranges.unit}`),
          otherwise: (schema) => schema.optional()
        }),
        otherwise: (schema) => schema.optional()
      }),
    vacantSnapBackTemperatureAdjustment: Yup.number("Setpoint Refresh Frequency required").typeError("Setpoint Refresh Frequency must be a number")
      .when('buildingThermostatMasterControl', {
        is: true,
        then: (schema) => schema.when('enableVacantSnapBack', {
          is: true,
          then: (schema) => schema.required("Setpoint Refresh Frequency required")
            .min(1, "Setpoint Refresh Frequency must be greater than 0"),
          otherwise: (schema) => schema.optional()
        }),
        otherwise: (schema) => schema.optional()
      }),
  });
};

export const createThermostatSchema = (buildingTempUnit = 'F') => {
  const ranges = getTemperatureRanges(buildingTempUnit);
  
  return Yup.object().shape({
    snapBackTemperature: Yup.number("Snap Back Setpoint required")
      .typeError("Snap Back Setpoint must be a number")
      .when('enableSnapBack', {
        is: true,
        then: (schema) => schema.required("Snap Back Setpoint required")
          .min(ranges.min, `Minimum temperature is ${ranges.min}${ranges.unit}`)
          .max(ranges.max, `Maximum temperature is ${ranges.max}${ranges.unit}`),
        otherwise: (schema) => schema.optional()
      }),
    autoTemperatureAdjustment: Yup.number("Setpoint Refresh Frequency required")
      .typeError("Setpoint Refresh Frequency must be a number")
      .when('enableSnapBack', {
        is: true,
        then: (schema) => schema.required("Setpoint Refresh Frequency required")
          .min(1, "Setpoint Refresh Frequency must be greater than 0"),
        otherwise: (schema) => schema.optional()
      }),
    hold: Yup.mixed().optional(),
    heatHoldTemperature: Yup.mixed().optional(),
    coolHoldTemperature: Yup.mixed().optional(),
  });
};

// Legacy exports for backward compatibility (deprecated)
export const thermostatSchema = createThermostatSchema('F');
export const globalThermostatSchema = createGlobalThermostatSchema('F');
